const importStatuses = {
	PENDING: "pending",
	IGNORED: "ignored",
	IN_PROGRESS: "in_progress",
	COMPLETED: "completed",
	FAILED: "failed",
};

export default importStatuses;
